export default __webpack_public_path__ + "static/media/480_dummy2016-grafikdesigner01-de.cd25aae6.png";